import { FormDialog } from '@ui-kit';

interface UserDeleteConfirmProps {
  open: boolean;
  email: string;
  isSelf: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
  errorMessage?: string;
}

export function UserDeleteConfirm({
  open,
  email,
  isSelf,
  onClose,
  onConfirm,
  isLoading = false,
  errorMessage,
}: UserDeleteConfirmProps) {
  return (
    <FormDialog
      open={open}
      title="사용자 삭제"
      onClose={onClose}
      onSubmit={isSelf ? () => {} : onConfirm}
      submitLabel={isLoading ? '처리 중...' : '삭제'}
      cancelLabel="취소"
    >
      <div>
        {isSelf ? (
          <div
            role="alert"
            style={{
              padding: 'var(--spacing-3)',
              background: 'color-mix(in srgb, var(--color-warning) 12%, var(--color-surface-muted))',
              border: '1px solid var(--color-warning)',
              borderRadius: 'var(--radius-md)',
              fontSize: 'var(--font-size-sm)',
              color: 'var(--color-warning)',
            }}
          >
            자기 자신을 삭제할 수 없습니다. 다른 관리자에게 요청하세요.
          </div>
        ) : (
          <>
            {errorMessage && (
              <div
                role="alert"
                style={{
                  marginBottom: 'var(--spacing-3)',
                  padding: 'var(--spacing-3)',
                  background: 'color-mix(in srgb, var(--color-danger) 12%, var(--color-surface-muted))',
                  border: '1px solid var(--color-danger)',
                  borderRadius: 'var(--radius-md)',
                  fontSize: 'var(--font-size-sm)',
                  color: 'var(--color-danger)',
                }}
              >
                {errorMessage}
              </div>
            )}
            <p style={{ fontSize: 'var(--font-size-sm)', color: 'var(--color-text-primary)', marginBottom: 'var(--spacing-3)' }}>
              <strong>{email}</strong> 사용자를 삭제하시겠습니까?
            </p>
            <div
              role="alert"
              style={{
                padding: 'var(--spacing-3)',
                background: 'color-mix(in srgb, var(--color-danger) 8%, var(--color-surface-muted))',
                border: '1px solid var(--color-danger)',
                borderRadius: 'var(--radius-md)',
                fontSize: 'var(--font-size-xs)',
                color: 'var(--color-danger)',
              }}
            >
              이 사용자는 더 이상 로그인할 수 없습니다. 이 작업은 되돌릴 수 없습니다.
            </div>
          </>
        )}
      </div>
    </FormDialog>
  );
}
